exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.md-app[data-v-e8da6b2c]{min-height:350px;border:1px solid rgba(0,0,0,0.12)\n}\n.md-drawer[data-v-e8da6b2c]{width:230px;max-width:calc(100vw - 125px)\n}\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/layouts/navigation.vue"],"names":[],"mappings":";AAAA,yBAAQ,iBAAiB,iCAAiC;CAAC;AAAA,4BAAW,YAAY,6BAA6B;CAAC","file":"navigation.vue","sourcesContent":[".md-app{min-height:350px;border:1px solid rgba(0,0,0,0.12)}.md-drawer{width:230px;max-width:calc(100vw - 125px)}\n"],"sourceRoot":""}]);

// exports
